document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wh-image]');
  if (!button) return;
  const gallery = button.closest('[data-wh-gallery]');
  const image = gallery.querySelector('.wh-gallery-main');
  image.removeAttribute('srcset');
  image.src = button.dataset.whImage;
  image.alt = button.getAttribute('aria-label').replace(/^View /, '');
  gallery.querySelectorAll('[data-wh-image]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-wh-variant]')) return;
  const selected = event.target.selectedOptions[0];
  const form = event.target.closest('form');
  form.querySelector('[data-wh-price]').textContent = selected.dataset.price;
  const gallery = form.closest('.wh-buybox').querySelector('[data-wh-gallery]');
  const image = gallery.querySelector('.wh-gallery-main');
  image.removeAttribute('srcset');
  image.src = selected.dataset.image;
  image.alt = ` ${event.target.dataset.productTitle || "Wash’d detergent"} — ${selected.textContent.split(' — ')[0]}`.trim();
  gallery.querySelectorAll('[data-wh-image]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
  form.querySelector('button[type="submit"]').disabled = selected.dataset.available !== 'true';
});

// Keep header menus mutually exclusive and dismissible with keyboard or pointer.
function initWashdHeader(header) {
  if (header.dataset.initialized) return;
  header.dataset.initialized = 'true';
  const menus = [...header.querySelectorAll('.wh-header-dropdown')];
  const closeMenus = (except) => menus.forEach((menu) => { if (menu !== except) menu.open = false; });
  menus.forEach((menu) => {
    menu.addEventListener('toggle', () => { if (menu.open) closeMenus(menu); });
    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
    });
  });
  document.addEventListener('click', (event) => {
    if (!header.contains(event.target) || event.target.closest('a')) closeMenus();
  });
  header.addEventListener('focusout', (event) => {
    if (event.relatedTarget && !header.contains(event.relatedTarget)) closeMenus();
  });

  const announcements = header.querySelector('.wh-promo-slides');
  const slides = [...announcements.querySelectorAll('[data-wh-promo-slide]')];
  let activeSlide = 0;
  if (slides.length > 1) {
    const rotation = window.setInterval(() => {
      if (!header.isConnected) { window.clearInterval(rotation); return; }
      if (document.hidden || announcements.matches(':hover') || announcements.contains(document.activeElement)) return;
      activeSlide = (activeSlide + 1) % slides.length;
      slides.forEach((slide, index) => { slide.hidden = index !== activeSlide; });
    }, 5000);
  }
}
document.querySelectorAll('[data-wh-header]').forEach(initWashdHeader);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-wh-header]').forEach(initWashdHeader);
});

document.addEventListener('click', (event) => {
  const filter = event.target.closest('[data-wh-filter]');
  if (!filter) return;
  const catalog = filter.closest('[data-wh-catalog]');
  catalog.querySelectorAll('[data-wh-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
  let count = 0;
  catalog.querySelectorAll('[data-wh-product]').forEach(card => {
    card.hidden = filter.dataset.whFilter !== 'all' && card.dataset.whProduct !== filter.dataset.whFilter;
    if (!card.hidden) count++;
  });
  catalog.querySelector('.wh-products').scrollLeft = 0;
  catalog.querySelector('[data-wh-filter-status]').textContent = `${count} ${count === 1 ? 'product' : 'products'} shown`;
});
